import { ColumnLinks } from '../menu/types';

// --------------------------------------------------------------------------

export const adjustInsuranceProductLinksWithFlags = ({
  insuranceNavUpdates,
  productLinks,
}: {
  insuranceNavUpdates?: boolean;
  productLinks: ColumnLinks;
}) => {
  if (!insuranceNavUpdates) {
    return productLinks;
  }
  let adjustedProductLinks = { ...productLinks };
  adjustedProductLinks.links = adjustedProductLinks.links.map((link) => {
    if (link.href.includes('/insurance/disability-insurance')) {
      return {
        ...link,
        href: link.href.replace(
          '/insurance/disability-insurance',
          '/product-overview/disability-insurance',
        ),
      };
    }
    if (link.href.includes('/insurance/life-insurance')) {
      return {
        ...link,
        href: link.href.replace(
          '/insurance/life-insurance',
          '/product-overview/life-insurance',
        ),
      };
    }
    if (link.href.includes('/insurance/long-term-care-insurance')) {
      return {
        ...link,
        text: 'Long-term care strategy',
        href: link.href.replace(
          '/insurance/long-term-care-insurance',
          '/product-overview/long-term-care-strategy',
        ),
      };
    }
    return link;
  });

  return adjustedProductLinks;
};

export const adjustInvestmentProductLinksWithFlags = ({
  investmentNavUpdates,
  productLinks,
}: {
  investmentNavUpdates?: boolean;
  productLinks: ColumnLinks;
}) => {
  if (!investmentNavUpdates) {
    return productLinks;
  }
  let adjustedProductLinks = { ...productLinks };
  adjustedProductLinks.links = adjustedProductLinks.links.map((link) => {
    if (link.href.includes('/annuities')) {
      return {
        ...link,
        href: link.href.replace('/annuities', '/product-overview/annuities'),
      };
    }
    if (link.href.includes('/investments/mutual-funds')) {
      return {
        ...link,
        href: link.href.replace(
          '/investments/mutual-funds',
          '/product-overview/mutual-funds',
        ),
      };
    }
    if (link.href.includes('/investments/managed-accounts')) {
      return {
        ...link,
        href: link.href.replace(
          '/investments/managed-accounts',
          '/product-overview/managed-accounts',
        ),
      };
    }
    return link;
  });

  return adjustedProductLinks;
};
